import React from "react"
import "../CSS/fonts.css"
import {PRANAV_PHOTO, RAJA_PHOTO, NEELI_PHOTO, PRIVACY} from "../Constants.js"
import "../CSS/workshop_digitalprivacy.css"
import NavBar from "../Components/NavBar.jsx"
import "../CSS/fonts.css"

let  Workshop_DigitalPrivacy =  () => {
    return (
        <>  
            <NavBar></NavBar>
            <h1 className = "roboto-condensed-700" style = {{marginLeft : "3%",marginRight : "3%", borderBottom : "5px solid black", paddingBottom : "2%"}}>International Workshop on Digital Privacy for Future Generation Healthcare</h1>
            <section className = "speaker-section-workshop">
                
                <h2 className = "roboto-condensed-700" >Workshop Chairs</h2>
                <div className = "speakers-workshop">
                    <div className = "speaker-workshop-item">
                        
                        <h3 className = "roboto-condensed-700">Pranav M Pawar</h3>
                        <h4 h4 className = "roboto-condensed-500">BITS Pilani Dubai Campus</h4>
                        <p className = "roboto-condensed-300"> pranav@dubai.bits-pilani.ac.in</p>
                    </div>
                    <div className = "speaker-workshop-item">
                        
                        <h3 className = "roboto-condensed-700">Raja Muthalagu</h3>
                        <h4 className = "roboto-condensed-500">BITS Pilani, Dubai, UAE</h4>
                        <p className = "roboto-condensed-300"> raja.m@dubai.bits-pilani.ac.in</p>
                    </div>
                    <div className = "speaker-workshop-item">
                        
                        <h3 className = "roboto-condensed-700">Mithun Mukharjee</h3>
                        <h4 className = "roboto-condensed-500">BITS Pilani, Dubai, UAE</h4>
                        <p className = "roboto-condensed-300"> mithun@dubai.bits-pilani.ac.in</p>
                    </div>
                    <div className = "speaker-workshop-item">
                        
                        <h3 className = "roboto-condensed-700">Neeli Rashmi Prasad</h3>
                        <h4 h3 className = "roboto-condensed-500" style = {{
                            fontSize : "20px"
                        }} >Chair, Healthcare Subgroup, IEEE Digital Privacy Initiative &amp; CEO and Co-Founder,
                SmartAvatar BV, Amsterdam, Netherlands</h4>
                        <p className = "roboto-condensed-300"> neeli.prasad@smartavatar.nl</p>
                    </div>
                </div>


                
            </section>


            <section className= "speaker-section-workshop">
                <h2 className = "roboto-condensed-700" >Keynote Speaker</h2>

                <div className = "speakers-workshop">
                <div className = "speaker-workshop-item">
                    <h3 className = "roboto-condensed-700">Mahbubul Alam</h3>
                    <h4 className = "roboto-condensed-500">Chairman</h4>
                    <h4 className = "roboto-condensed-500">SmartAvatar, California, USA</h4>
                </div>
                </div>
            </section>
            
            
            
            <section className = "digital-privacy-important-dates ">
                <h2 className = "roboto-condensed-700" style = {{textAlign : "center"}}>Important Dates</h2>
                <div class = "digital-privacy-important-dates-items ">
                    <div class = "digital-privacy-important-dates-item">
                        <p style = {{display : "flex", justifyContent : "center"}}>
                            <p class = "event-date roboto-condensed-700" style = {{textDecoration : "line-through"}} >15<sup>th</sup> AUG 2025</p>
                            <p class = "event-date roboto-condensed-700" >10<sup>th</sup> SEP 2025</p>
                        </p>
                        <p class = "event-name roboto-condensed-300">Submission of Papers</p>
                    </div>
                    <div class = "digital-privacy-important-dates-item">
                        <p class = "event-date roboto-condensed-700">30<sup>th</sup> SEP 2025</p>
                        <p class = "event-name roboto-condensed-300">Acceptance Notification</p>
                    </div>
                    <div class = "digital-privacy-important-dates-item">
                        <p class = "event-date roboto-condensed-700">15<sup>th</sup> OCT 2025 </p>
                        <p class = "event-name roboto-condensed-300">
                        Camera Ready Paper Deadline</p>
                    </div>
                </div>
            </section>

            <section className = "guidelines-section">
                <h2 className = "roboto-condensed-700" >Submission Guidelines</h2>

                <p className = "roboto-300">
                    Authors can submit the paper to workshop clicking <a href = "https://cmt3.research.microsoft.com/User/Login?ReturnUrl=%2FCINS2025">here</a>. The author
should select track “Workshop on Digital Privacy for Future Generations Healthcare”.
Accepted, registered and presented papers will be published in the CINS2025 proceedings
and the IEEE Xplore as well as other Abstracting and Indexing (A&I) databases. Please visit
the conference website for more information regarding the paper preparation and submission
guidelines (in the Home Tab).
                </p>
            </section>
            
            <a className = "pdf-item" href = {PRIVACY} style = {{textAlign : "center", color : "black", textDecoration : "none"}}><h3 className = "roboto-condensed-700">Click Here for Workshop Call For Paper</h3></a>
        </>
    )
}

export default Workshop_DigitalPrivacy
